module.exports = __webpack_public_path__ + "img/26-chrysler-alt.890d8503.png";